<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget @tab="switchTab" activeTab="podcast" />
      <div class="tab-options">
        <b-button type="is-primary" @click="toggleModal = true">ADD NEW</b-button>
      </div>
    </div>
    <div class="wrapper-body" v-if="!loading && allData.length > 0 && !showEpisodes"
      :class="{ activeSide: $store.state.sidebar }">
      <dataCard :podCastCard="true" @dataClick="viewDetails(data)" @edit="edit(data)"
        @deleteMedia="deletePodcast(data.id)" v-for="(data, index) in allData" :key="index" :dataObj=data />
    </div>
    <div v-if="loading || allData.length == 0 && !showEpisodes">
      <widgetNotfound v-if="loading" title="Please Wait..." subtitle="Loading Data..."></widgetNotfound>
      <widgetNotfound v-else title="No Data Found" subtitle="No records available at the moment. Add New">
      </widgetNotfound>
    </div>
    <div class="wrapper-details" v-if="showEpisodes" :class="{ activeSide: $store.state.sidebar }">
      <div class="podcasts_header">
        <div class="action">
          <b-button @click="selected_data = null; showEpisodes = false; viewedEpisode = false"
            type="is-black">BACK</b-button>
          <p>{{ selected_podcast.title }}</p>
        </div>
        <b-button type="is-primary" @click="toggleEpModal = true">ADD NEW EPISODE</b-button>
      </div>
      <div class="podcasts_body">
        <div class="podcasts_body_series" v-if="!loadingEpisodes && selected_data.length > 0">
          <div class="podcasts_body_series_card" v-for="(episode, index) in selected_data" :key="index">
            <div class="podcast_serie-body">
              <div class="podcast-cover" @click="viewedEpisode = episode">
                <img :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + episode.cover" alt="Cover Image"
                  v-if="episode.cover">
                <b-skeleton v-else id="img-skeleton"></b-skeleton>
              </div>
              <div class="podcast-data">
                <div class="podcast-data-header">
                  <div class="podcast-data-header-title" @click="viewedEpisode = episode">
                    <h1>{{ episode.title }}</h1>
                  </div>
                  <div class="playlist-action">
                    <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                      <template #trigger>
                        <b-icon icon="dots-vertical" type="is-black"></b-icon>
                      </template>
                      <b-dropdown-item @click="editEpisode(episode)" aria-role="listitem">Update</b-dropdown-item>
                      <b-dropdown-item @click="deleteEpisode(episode.id)" aria-role="listitem">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <p class="podcast-data-description" @click="viewedEpisode = episode">{{ episode.description }}</p>
                <div class="podcast-data-meta" @click="viewedEpisode = episode">
                  <div class="podcast-data-media">
                    <b-icon @click.native="playMedia(episode)" icon="play" type="is-white"></b-icon>
                  </div>
                  <p>{{ episode.duration ? toHHMMSS(episode.duration) : '--' }}</p>
                </div>
              </div>
            </div>
            <hr>
          </div>
        </div>
        <div v-else>
          <widgetNotfound v-if="loadingEpisodes" title="Please Wait..." subtitle="Loading Data..."></widgetNotfound>
          <widgetNotfound v-else title="No Data Found" subtitle="No records available at the moment. Add New">
          </widgetNotfound>
        </div>
        <div class="podcasts_body_selected" :class="{ visibleAside: viewedEpisode }" v-if="viewedEpisode">
          <b-button type="is-primary" @click="viewedEpisode = null">BACK</b-button>
          <div class="podcasts_body_selected_cover">
            <img :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + viewedEpisode.cover" alt="Cover Image"
              v-if="viewedEpisode.cover">
            <b-skeleton v-else id="img-skeleton"></b-skeleton>
          </div>
          <h1 class="podcast_name">{{ viewedEpisode.title }}</h1>
          <div class="podcasts_body_selected_data">
            <h1>Description</h1>
            <p v-if="viewedEpisode.description">{{ viewedEpisode.description }}</p>
            <div class="spaced-skeleton" v-else>
              <b-skeleton></b-skeleton>
              <b-skeleton width="85%"></b-skeleton>
              <b-skeleton width="75%"></b-skeleton>
            </div>
          </div>
          <br>
          <div class="podcasts_body_selected_cover">
            <p>Lagging Image</p><br>
            <img :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + viewedEpisode.lagging_image"
              alt="Cover Image" v-if="viewedEpisode.lagging_image">
            <b-skeleton v-else id="img-skeleton"></b-skeleton>
          </div>
          <p>Episode Number: {{ viewedEpisode.episode_number ? viewedEpisode.episode_number : '--' }}</p>
          <p>Intro Start Time: {{ viewedEpisode.intro_start_time ? toHHMMSS(viewedEpisode.intro_start_time) : '--' }}
          </p>
          <p>Intro End Time: {{ viewedEpisode.intro_end_time ? toHHMMSS(viewedEpisode.intro_end_time) : '--' }}</p>
          <p>Podcast End Time: {{ viewedEpisode.podcast_end_time ? toHHMMSS(viewedEpisode.podcast_end_time) : '--' }}
          </p>
          <p>Visibility : {{ viewedEpisode.visibility ? viewedEpisode.visibility : '--' }}</p>
        </div>
        <div class="podcasts_body_selected" v-else>
          <widgetNotfound title="No Episode Data" subtitle="Please Click on an episode to view data"></widgetNotfound>
        </div>
      </div>
    </div>

    <AddNewPodcast @refresh="getAllPodcasts" v-if="toggleModal"
      @closeModal="toggleModal = false; editPodcastData = null" :dataObj="editPodcastData" />
    <AddNewPodcastEp v-if="toggleEpModal" :podcastId="selected_podcast.id" :nextEpisode="selected_podcast.lastEpisode"
      @refresh="viewDetails(selected_podcast)" @closeModal="toggleEpModal = false; editPodcastEpData = null"
      :dataObj="editPodcastEpData" :podcastCover="selected_data.cover" />
    <!-- ClapprPlayer -->
    <b-modal v-model="show_player" :width="800">
      <div style="height: 500px" v-if="viewedEpisode">
        <ClapprPlayer :src="`${$store.state.ASSETS_VIDEO_BASE_URL}${viewedEpisode.videoPath}`" type="hls">
        </ClapprPlayer>
      </div>
    </b-modal>

  </div>
</template>

<script>
import AddNewPodcast from './modals/addNewPodcast.vue';
import AddNewPodcastEp from './modals/addNewPodcastEp.vue'
import dataCard from './components/dataCard.vue';
import TabsWidget from './components/TabsWidget.vue';
export default {
  data() {
    return {
      show_player: false,
      toggleModal: false,
      selected_data: null,
      isPlaying: false,
      toggleEpModal: false,
      editPodcastData: null,
      editPodcastEpData: null,
      loading: true,
      showEpisodes: false,
      loadingEpisodes: false,
      selected_podcast: null,
      viewedEpisode: null,
      form: {
        title: '',
        description: '',
        topics: [],
        directors: [],
        playlist: [],
        visibility: '',
        owner: ''
      },
      allData: []
    }
  },
  components: { dataCard, AddNewPodcast, AddNewPodcastEp, TabsWidget },
  methods: {
    playMedia(item) {
      let vm = this;
      vm.viewedEpisode = item;
      vm.show_player = !vm.show_player
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    edit(data) {
      let vm = this;
      vm.editPodcastData = data
      vm.toggleModal = true
    },
    editEpisode(data) {
      let vm = this;
      vm.editPodcastEpData = data;
      vm.toggleEpModal = true
    },
    viewDetails(data) {
      let vm = this;
      vm.loadingEpisodes = true;
      vm.selected_podcast = data;
      vm.viewedEpisode = null
      vm.$store.dispatch('GET_PODCASTS_EPISODES', { id: data.id })
        .then((res) => {
          vm.loadingEpisodes = false;
          vm.selected_data = res.data.return;
          vm.showEpisodes = true;
        })
        .catch((err) => {
          vm.loadingEpisodes = false;
          vm.selected_data = [];
          vm.showEpisodes = true;
        })
      // vm.selected_data = data;
      vm.showEpisodes = true;
    },
    getAllPodcasts() {
      let vm = this;
      vm.loading = true;
      vm.$store.dispatch('GET_PODCASTS')
        .then((res) => {
          vm.loading = false;
          vm.allData = res.data.return;
        })
        .catch((err) => {
          vm.loading = false;
          vm.allData = [];
        })
    },
    deletePodcast(id) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: 'Deleting Podcast',
        message: 'Are you sure you want to delete this Podcast?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          vm.$store.dispatch('DELETE_PODCASTS', { id: id })
            .then(res => {
              vm.$notify({
                type: 'is-success',
                message: 'Podcast Deleted Successfully',
                duration: 1000,
                position: 'is-top-right',
                hasIcon: true,
              })
              vm.getAllPodcasts();
            })
            .catch(err => {
              vm.$notify({
                type: 'is-danger',
                message: 'Error Deleting Podcast',
                duration: 1000,
                position: 'is-top-right',
                hasIcon: true,
              })
            })
        }
      })
    },
    deleteEpisode(id) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: 'Deleting Podcast Episode',
        message: 'Are you sure you want to delete this episode?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          vm.$store.dispatch('DELETE_PODCASTS_EPISODES', { id: id })
            .then(res => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Episode Deleted Successfully',
              });
              vm.viewDetails(vm.selected_podcast);
            })
            .catch(err => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
              console.log(err);
            })
        }
      })
    }
  },
  mounted() {
    let vm = this;
    vm.getAllPodcasts();
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: fit-content;
    // height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding-left: 6px;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-bottom: 3px solid transparent;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(6, calc(100%/6.4));
    row-gap: 50px;
    overflow-y: auto;
    justify-content: space-between;

    @media (max-width: 1307px) {
      grid-template-columns: repeat(5, calc(100%/5.3));
    }

    @media (max-width: 1000px) {
      grid-template-columns: repeat(4, calc(100%/4.25));
    }

    @media (max-width: 768px) {
      grid-template-columns: repeat(3, calc(100%/3.15));
      row-gap: 30px;
    }

    @media (max-width: 600px) {
      grid-template-columns: repeat(2, calc(100%/2.05));
    }

    @media (max-width: 450px) {
      grid-template-columns: repeat(1, 1fr);
    }

    &.activeSide {
      grid-template-columns: repeat(5, calc(100%/5.3));

      @media (max-width: 1300px) {
        grid-template-columns: repeat(4, calc(100%/4.25));
      }

      @media (max-width: 1100px) {
        grid-template-columns: repeat(3, calc(100%/3.15));
      }

      @media (max-width: 966px) {
        grid-template-columns: repeat(4, calc(100%/4.25));
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(3, calc(100%/3.15));
        row-gap: 30px;
      }

      @media (max-width: 600px) {
        grid-template-columns: repeat(2, calc(100%/2.05));
      }

      @media (max-width: 450px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }
  }

  .wrapper-details {
    display: flex;
    flex-direction: column;
    padding: 0;
    row-gap: 0;

    &.activeSide {
      .podcasts_body {
        .podcasts_body_series {
          @media (max-width: 1040px) {
            padding-right: 20px;
          }

          @media (max-width: 966px) {
            padding-right: 40px;
          }
        }

        .podcasts_body_selected {
          @media (max-width: 1040px) {
            padding-left: 20px;
          }

          @media (max-width: 966px) {
            padding-left: 40px;
          }
        }
      }
    }

    .podcasts_header {
      padding: 5px 20px;
      justify-content: space-between;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.20);
      position: sticky;
      top: 0;
      background: white;
      z-index: 1;
      overflow-x: auto;
      column-gap: 30px;

      .action {
        display: flex;
        align-items: center;
        column-gap: 10px;

        p {
          white-space: nowrap;
        }
      }
    }

    .podcasts_body {
      padding: 0px;
      display: grid;
      grid-template-columns: 60% 40%;
      padding: 20px;
      height: calc(100vh - 170px);
      overflow-y: auto;
      position: relative;

      @media (max-width: 800px) {
        grid-template-columns: 100%;
      }

      .podcasts_body_series {
        display: flex;
        flex-direction: column;
        border-right: 1px solid rgba(0, 0, 0, 0.20);
        padding-right: 20px;

        @media (max-width: 800px) {
          padding-right: 0;
          border: none;
        }

        .podcasts_body_series_card {
          background-color: #fff;
          padding: 8px;
          border-radius: 5px;
          cursor: pointer;

          .podcast_serie-body {
            display: flex;
            column-gap: 15px;

            @media (max-width: 430px) {
              flex-direction: column;
            }

            .podcast-cover {
              width: 145px;
              height: 145px;
              flex-shrink: 0;
              border-radius: 5px;
              overflow: hidden;
              position: relative;

              .playlist-action {
                position: absolute;
                width: 30px;
                height: 30px;
                top: 5px;
                right: 5px;
                z-index: 1;
              }

              .b-skeleton.is-animated {
                height: 100%;

                .b-skeleton-item.is-rounded {
                  height: 100%;
                }
              }

              @media (max-width: 800px) {
                width: 120px;
                height: 120px;
              }

              @media (max-width: 430px) {
                width: 100%;
                height: 200px;
                margin-bottom: 10px;
              }

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }

              button {
                position: absolute;
                bottom: 10px;
                right: 10px;
              }
            }

            .podcast-data {
              width: calc(100% - 145px);

              .podcast-data-header {
                display: flex;
                width: 100%;

                .podcast-data-header-title {
                  width: calc(100% - 10px);

                  h1 {
                    font-size: 19px;
                    font-weight: 600;
                    margin-bottom: 5px;
                  }
                }

                .playlist-action {
                  width: 10px;
                }
              }

              p.podcast-data-description {
                white-space: wrap;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                width: 100%;
                margin-bottom: 18px;
              }

              .podcast-data-meta {
                display: flex;
                align-items: center;
                column-gap: 18px;

                @media (max-width: 800px) {
                  column-gap: 10px;

                  p {
                    font-size: 15px;
                  }
                }

                .podcast-data-media {
                  width: 30px;
                  height: 30px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  padding: 5px;
                  border-radius: 50%;
                  background: #1C1C1C;
                  cursor: pointer;
                }
              }
            }
          }

          &:last-of-type {
            hr {
              display: none;
            }
          }

          hr {
            background: rgba(0, 0, 0, 0.20);
            height: .5px;
          }
        }
      }

      .podcasts_body_selected {
        padding-left: 40px;

        @media (max-width: 800px) {
          position: absolute;
          top: 0;
          right: 0;
          padding: 15px;
          border-left: 1px solid rgba(0, 0, 0, 0.20);
          background: white;
          min-height: 100vh;
          width: 400px;
          display: none;
        }

        @media (max-width: 560px) {
          width: 300px;
        }

        @media (max-width: 360px) {
          width: 100%;
        }

        button {
          display: none;
          margin-bottom: 15px;

          @media (max-width: 800px) {
            display: block;
          }
        }

        &.visibleAside {
          display: block;
        }

        .podcasts_body_selected_cover {
          width: 270px;
          height: 270px;
          border-radius: 5px;
          overflow: hidden;
          margin-bottom: 20px;

          .b-skeleton {
            height: 100%;

            .b-skeleton-item {
              height: 100%;
            }
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        h1.podcast_name {
          font-size: 25px;
          font-weight: 700;
          margin-bottom: 15px;
        }

        .podcasts_body_selected_data {
          h1 {
            font-size: 19px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
